import { render, staticRenderFns } from "./TableResumenEquipo.vue?vue&type=template&id=c560630a&scoped=true&"
import script from "./TableResumenEquipo.vue?vue&type=script&lang=js&"
export * from "./TableResumenEquipo.vue?vue&type=script&lang=js&"
import style0 from "./TableResumenEquipo.vue?vue&type=style&index=0&id=c560630a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c560630a",
  null
  
)

export default component.exports